"use client";

import { motion } from "framer-motion";
import { LookupResponseExplorer } from "@/components/shared/lookup-response-explorer";
import { BreachesSection } from "./breaches-section";
import { BREACHES_DATA_POINTS } from "./breaches-data";

const BREACHES_RESPONSE_KEYS: Record<string, string[]> = {
  "Exposure status": ["exposure_status"],
  "Times seen": ["times_seen"],
  "k-anonymity": ["prefix"],
  "Breach sources": ["breach_sources", "name"],
  "Risk grade": ["risk_grade"],
  Remediation: ["remediation", "action"],
};

const BREACHES_RESPONSE_ITEMS = BREACHES_DATA_POINTS.map((item) => ({
  ...item,
  responseKeys: BREACHES_RESPONSE_KEYS[item.title] ?? [],
}));

const BREACHES_RESPONSE: Record<string, unknown> = {
  exposure_status: "found",
  times_seen: 128,
  prefix: "5BAA6",
  breach_sources: [{ name: "Example breach A" }, { name: "Example breach B" }],
  risk_grade: "high",
  remediation: {
    action: "rotate_secret",
    recommendation: "Reset this password on every account where it was reused.",
  },
};

export function BreachesDataPoints() {
  return (
    <BreachesSection>
      <section className="pb-40">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-10"
        >
          <h2 className="mb-3 text-2xl font-semibold tracking-tight sm:text-3xl">
            Everything behind a breach check
          </h2>
          <p className="max-w-2xl text-base text-text-tertiary">
            One request tells you if a secret is compromised and how exposed it is.
          </p>
        </motion.div>

        <LookupResponseExplorer items={BREACHES_RESPONSE_ITEMS} response={BREACHES_RESPONSE} />
      </section>
    </BreachesSection>
  );
}
